var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.canViewLaunchPad)?_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.appstoreTab !== _vm.tabTypes.integrate),expression:"appstoreTab !== tabTypes.integrate"}]},[_c('LaunchPadApps',{attrs:{"in-appstore":_vm.inAppstore,"loading":_vm.loading}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }